import Count from "../Count/Count";

const AnalyticCard = ({backColor = '#FFEEEE', color = '#FF635A', data}) => {
    const numb = String(data?.number);
    return(
        <li className={'analytics-card flex border-radius-8 gap-20'} style={{backgroundColor: backColor, color: color}}>
            <div className="number sf-bold flex">
                <Count number={numb} duration={1}></Count>
                <span className={'font-30'}>{data?.suf}</span></div>
            <div className="title sf-medium">{data?.title}</div>
        </li>
    )
}

export default AnalyticCard;
